import React, { useContext, useRef } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
// import Link from '@mui/material/Link';
import { Link, useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { Alert } from "@mui/material";
import AuthContext from "../Store/auth-store";
import Copyright from "../Commons/Copyright"

export default function SignIn() {
  const authContext = useContext(AuthContext);
  const rememberMeRef = useRef(null)
  let navigate = useNavigate();
  let [errorDisplay, setErrorDisplay] = React.useState("");
  if (authContext.currentUser) {
    alert("You are already logged in, dashboard will open.");
    navigate("/dashboard");
  }
  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    let email = data.get("email");
    let password = data.get("password");
    let shouldRemember = rememberMeRef.current.checked;
    if (email.trim() === "") {
      setErrorDisplay(
        <Alert severity="error">Please enter valid email.</Alert>
      );
      return;
    }
    if (password === "") {
      setErrorDisplay(<Alert severity="error">Please enter a password.</Alert>);
      return;
    }
    try {
      await authContext.onLogin(email, password, shouldRemember);
      navigate("/dashboard");
    } catch (e) {
      setErrorDisplay(<Alert severity="error">{e.message}</Alert>);
      return;
    }
  };
  return (
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>
          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{ mt: 1 }}
          >
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
            />
            <FormControlLabel
              control={<Checkbox value="remember" inputRef={rememberMeRef} color="primary" />}
              label="Remember me"
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Sign In
            </Button>
            <Grid container>
              {/* <Grid item xs>
                <Link href="#" variant="body2">
                  Forgot password?
                </Link>
              </Grid> */}
              <Grid item>
                <Link to="/register" variant="body2">
                  {"Don't have an account? Sign Up"}
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Box>
        <Box>{errorDisplay}</Box>
        <Copyright sx={{ mt: 8, mb: 4 }} />
      </Container>
  );
}
